export default __webpack_public_path__ + "c5f216be2a233ff24e90cca4fc827adc.svg";